import {Component, OnInit} from "@angular/core";
import {MatDialogRef} from "@angular/material";
import {ProjectService} from "../../services/project.service";
import {NotificationService} from "../../services/notification.service";
import {FreelancersService} from "../../services/freelancers.service";
import {environment} from "../../../environments/environment";

@Component({
    selector: 'app-freelancer-dialog',
    templateUrl: 'freelancer-dialog.component.html',
})
export class FreelancerDialogComponent implements OnInit{
    public item: any;
    public is_new: boolean;
    env = environment

    constructor(
        public dialogRef: MatDialogRef<FreelancerDialogComponent>,
        private freelancerServ: FreelancersService,
        private notifServ: NotificationService
    ) {
    }

    ngOnInit(){
    }

    saveFreelancer(){
        if(this.is_new){
            this.freelancerServ.addFreelancer(this.item.key, this.item).then(
                r => {
                    this.dialogRef.close(true);
                    this.notifServ.sendSuccess( 'Freelancer info have been added');
                }
            )
        }else{
            this.freelancerServ.updateFreelancer(this.item.key, this.item, true).then(
                r => {
                    this.dialogRef.close(true);
                    this.notifServ.sendSuccess( 'Freelancer info have been updated');
                }
            )
        }

    }

}


// WEBPACK FOOTER //
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/dialogs/freelancer/freelancer-dialog.component.ts